import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import RouteWithDefaultLayout from "./components/shared/RouteWithDefaultLayout";
import ModernLoader from "./components/shared/ModernLoader";

const ModernHomepage = lazy(() => import("./components/home/ModernHomepage"));
const NotFound = lazy(() => import("./pages/NotFound"));
const Contact = lazy(() => import("./pages/Contact/ModernContact"));
const Services = lazy(() => import("./pages/Services/ModernServices"));
const AboutUs = lazy(() => import("./pages/AboutUs/ModernAboutUs"));

const App = () => {
    return (
        <Router>
            <Suspense fallback={<ModernLoader />}>
                <Routes>
                    <Route path="/contact" element={<RouteWithDefaultLayout component={Contact} />} />
                    <Route path="/services" element={<RouteWithDefaultLayout component={Services} />} />
                    <Route path="/about-us" element={<RouteWithDefaultLayout component={AboutUs} />} />
                    <Route path="/" element={<RouteWithDefaultLayout component={ModernHomepage} />} />
                    <Route path="*" element={<RouteWithDefaultLayout component={NotFound} />} />
                </Routes>
            </Suspense>
        </Router>
    );
};

export default App;
